import { atom } from 'jotai';

const pdpIsEditOrderSuccessAtom = atom(false);

export default pdpIsEditOrderSuccessAtom;
